import { Device, WebsiteMenu } from '@tempi/core-renderer';
import { userSelectedConstants } from 'constants/index';
import { getUserSelectedInfo } from 'helpers/env';
import { useTenantConfig } from 'hooks';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import { PbService } from '../service';
import { Content } from '../types';

type UsePbPageReturn = {
  content?: Content;
  menu?: WebsiteMenu[];
  websiteId?: number;
};
type UsePbPage = (params: {
  page: string;
  device: Device;
  defaultValue?: UsePbPageReturn;
  languageCode?: string;
}) => UsePbPageReturn & {
  loading?: boolean;
  error?: string;
};

export const usePbPage: UsePbPage = ({
  page,
  device,
  defaultValue,
  languageCode,
}) => {
  const {
    tempiWebsiteDomain,
    epicEcom480,
    showPbPagesFromWebsiteEditor,
    isMobile,
  } = useTenantConfig();
  const router = useRouter();
  const terminalIdFromCookies = getUserSelectedInfo(
    userSelectedConstants.TERMINAL_ID,
    isMobile,
    true,
  );
  const terminalId = terminalIdFromCookies
    ? Number(terminalIdFromCookies)
    : undefined;
  const isShowPbPageContent =
    showPbPagesFromWebsiteEditor &&
    // top-level only: /buildpc --> enable; /p/buildpc --> disable (resolve by host)
    /^\/(buildpc|nvidia)(\/|\?|#|$)/i.test(router.asPath);

  const { data, error, isValidating } = useSWR(
    [page, device, languageCode, terminalIdFromCookies],
    async (page, device) => {
      const builder = new PbService(
        epicEcom480 || isShowPbPageContent
          ? tempiWebsiteDomain || ''
          : window?.location?.hostname || '',
        window?.location?.hostname,
        epicEcom480 || isShowPbPageContent || false,
        languageCode,
      );
      const { content, menu, websiteId }: UsePbPageReturn =
        await builder.getContentPage(page, device, terminalId);

      return { content, menu, websiteId };
    },
    {
      fallbackData: defaultValue,
      revalidateOnFocus: false,
    },
  );

  return {
    ...data,
    error,
    loading: isValidating,
  };
};
